import ContentLoader from 'react-content-loader'
import React from 'react'

const AlgoliaFilterPlaceholder = React.memo(props => (
  <ContentLoader
    speed={2}
    width={294}
    height={48}
    viewBox="0 0 294 48"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="12" ry="12" width="294" height="48" />
  </ContentLoader>
))

export default AlgoliaFilterPlaceholder
